import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';

import { TranslationPipe } from '@rent2end/core/translation';

@Component({
  selector: 'r2e-avatar',
  imports: [MatIconButton, MatIcon, TranslationPipe],
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  src = input<string | null>();
}
